import { useEffect, useState } from "react"
import { NavigationBarSimple } from "./NavigationBarSimple"
import { PropertyInfoView } from "src/propertyInfoTemplates/PropertyInfoView"
import { PersonInfoView } from "./PersonInformationView"


export function PropertyInfoQuery() {
  let [bfeNr, setBfeNr] = useState<string>()
  const [query] = useState(new URLSearchParams(new URL(document.URL).search))

  useEffect(() => {
    if (query.has("bfeNr")) {
      let bfeNr = query.get("bfeNr")!
      setBfeNr(bfeNr)
    }
  }, [])

  if (!bfeNr) {
    return "Loading"
  }

  return (
    <NavigationBarSimple title="Ejendoms info" >
      <div className='Paper-MitProp'>
        <div className='Container-MitProp PropertyInfoDestroyer' style={{ padding: "0.5cm" }}>
          <PropertyInfoView bfeNr={bfeNr} foldetUd={true} cols={1} allowExtendedInformation={true} />
        </div>
      </div>
    </NavigationBarSimple>
  )
}

export function PersonInfoQuery() {
  let [date, setDate] = useState<Date>()
  let [name, setName] = useState<string>()
  let [getError, setError] = useState("")
  const [query] = useState(new URLSearchParams(new URL(document.URL).search))

  useEffect(() => {
    if (query.has("name") && query.has("date")) {
      let name = (query.get("name")!)
      let date = new Date(query.get("date")!)
      setName(name)
      setDate(date)
    } else {
      setError("Missing query")
    }
  }, [])

  if (getError) {
    return "Error" + getError
  }

  if (!(name && date)) {
    return "Loading"
  }

  return (
    <NavigationBarSimple title="Ejendoms info" >
      <div className='Paper-MitProp'>
        <div className='Container-MitProp PropertyInfoDestroyer' style={{ padding: "0.5cm" }}>
          <PersonInfoView personInfo={{ navn: name, foedselsdato: date }} foldetUd={true} cols={1} />
        </div>
      </div>
    </NavigationBarSimple>
  )
}